define('../app/fukit/service/pagination.service',['require','exports','module','underscore','evicommon/spf/model/paginate'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Paginate = require('evicommon/spf/model/paginate');

  var PaginationService = {
    //prettier-ignore
    radioRequests: {
      'paginationService isLastPage'    : 'isLastPage',
      'paginationService isFirstPage'   : 'isFirstPage',
      'paginationService previousPage'  : 'previousPage',
      'paginationService nextPage'      : 'nextPage',
      'paginationService pageCountTitle': 'pageCountTitle'
    },

    nextPage: function(pageModel, state, statePageAttribute) {
      var pageNumber = pageModel.get(Paginate.PAGE);
      pageModel.set(Paginate.PAGE, pageNumber + 1);

      if (state) {
        state.set(statePageAttribute || 'pageNumber', pageNumber + 1);
      }
    },

    previousPage: function(pageModel, state, statePageAttribute) {
      var pageNumber = pageModel.get(Paginate.PAGE);
      pageModel.set(Paginate.PAGE, pageNumber - 1);

      if (state) {
        state.set(statePageAttribute || 'pageNumber', pageNumber - 1);
      }
    },

    isLastPage: function(pageModel) {
      //prettier-ignore
      var pageNumber = pageModel.get(Paginate.PAGE),
          pageCount  = pageModel.get(Paginate.TOTAL_PAGES);
      // adds suppport for simple pagination view
      return !pageCount || pageNumber == pageCount;
    },

    isFirstPage: function(pageModel) {
      //prettier-ignore
      var pageNumber = pageModel.get(Paginate.PAGE),
          pageCount  = pageModel.get(Paginate.TOTAL_PAGES);
      return pageNumber == 1;
    },

    pageCountTitle: function(pageModel) {
      //prettier-ignore
      var pageNumber     = pageModel.get(Paginate.PAGE),
          pageSize       = Number(pageModel.get(Paginate.SIZE)),
          totalItems     = Number(pageModel.get(Paginate.TOTAL_ITEMS)),
          itemStartIndex = (pageNumber - 1) * pageSize + 1,
          itemEndIndex   = Math.min(totalItems, itemStartIndex + pageSize - 1),
          title          = String(Math.min(itemStartIndex, totalItems)) + '-' + String(itemEndIndex) + ' of ' + String(totalItems);

      return _.isNaN(itemStartIndex) || _.isNaN(itemEndIndex) ? '' : title;
    },
  };

  module.exports = PaginationService;
});

